import { Card, CardContent, Chip, makeStyles } from "@material-ui/core";
import Checked from "../../assets/checked.png";

const useStyles = makeStyles({
  root: {
    maxWidth: "100%",
    borderRadius: 17,
    padding: "20px 24px",
    border: "1px solid #CCCCCC",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    height: "56px"
  },
  cardContentEnabled: {
    padding: "0px !important",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  cardContentLimited: {
    padding: "0px !important",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  productBenefit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "-0.4px",
    margin: 0,
    padding: 0,
    textAlign: "left",
    marginBottom: "8px",
  },
  description: {
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "-0.4px",
    margin: 0,
    padding: 0,
    textAlign: "left",
    color: "#707070",
  },
  enabledIcon: {
    height: "20px",
    width: "20px",
    marginLeft: "14px",
  },
  chip: {
    fontSize: "12px",
    color: "#28a382",
    marginLeft: "14px",
    borderColor: "#28a382",
    fontFamily: "lexend, sans-serif",
    fontWeight: 400,
    letterSpacing: "-0.2px",
  },
});

const ProductBenefitCard = ({ title, description, status }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent
        className={
          status === "Enabled"
            ? classes.cardContentEnabled
            : classes.cardContentLimited
        }
      >
        <div className={classes.productBenefit}>
          <p className={classes.title}>{title}</p>
          <p className={classes.description}>{description}</p>
        </div>

        {status === "Enabled" ? (
          <img src={Checked} className={classes.enabledIcon} alt="Enabled" />
        ) : (
          <Chip
            variant="outlined"
            size="small"
            label={status}
            className={classes.chip}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default ProductBenefitCard;
